import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TopServiceEffects } from './effects';
import { reducer } from './reducer';
import { TopServiceFacade } from './facade';
import { stateName } from './selectors';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(stateName, reducer), EffectsModule.forFeature([TopServiceEffects])],
  exports: [],
  providers: [TopServiceFacade],
  declarations: [],
})
export class TopServiceStateModule {}
